export default "__VITE_ASSET__Fvi2ka86__"